import { render, staticRenderFns } from "./SalvamentoAutomatico.vue?vue&type=template&id=524b377f&scoped=true"
import script from "./SalvamentoAutomatico.vue?vue&type=script&lang=js"
export * from "./SalvamentoAutomatico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b377f",
  null
  
)

export default component.exports